// extracted by mini-css-extract-plugin
module.exports = {"floatingBox":"BillSectionModal_floatingBox__q4n7g","scrollContent":"BillSectionModal_scrollContent___sxZ2","closeButtonContainer":"BillSectionModal_closeButtonContainer__QPT1N"};